import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NavigationBar from '../../../components/Navigationbar/Navigationbar';
import Headline from '../../../components/headline/Headline';
import Stylebutton from '../../../components/buttons/stylebutton/Stylebutton';

import { post, Token } from '../../../Script/Session';
import { haspermission } from '../../../Script/Permission';
import { Update } from '@mui/icons-material';

function SubKathegorieCreation() {



  return (
    <>

    </>
  );
}

export default SubKathegorieCreation;
